<template lang="pug">
  .pagination()
    .pagination__item-first(:class="(page == 1) ? 'pagination__item--disabled' : ''", @click="changePage('first')")
      a
    paginate(v-model="page" :page-count="pageCount" :page-range="3" :margin-pages="2" :click-handler="changePage" :prev-text="''" :next-text="''" :container-class="'pagination__paginate'" :page-class="'pagination__item'" :prev-class="'pagination__item-prev'" :next-class="'pagination__item-next'" :active-class="'pagination__item--active'" :disabled-class="'pagination__item--disabled'")
    .pagination__item-last(:class="(page == pageCount) ? 'pagination__item--disabled' : ''", @click="changePage('last')")
      a
</template>

<script>
  // @ is an alias to /src
  import '@/components/common/pagination/pagination.styl';

  import EventBus from '@/eventBus';
  import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';

  export default {
    name: 'Pagination',

    props: ['activePage', 'pageCount'],

    mixins: [AjaxHelpersVue],

    data() {
      return {
        page: this.activePage
      }
    },

    components: {

    },

    created() {
      EventBus.$on('resetPagination', params => {
        this.page = 1;
      });
    },

    methods: {
      changePage(page) {
        if(page == 'first') {
          this.page = 1;
        } else if(page == 'last') {
          this.page = this.pageCount;
        }

        window.history.pushState(null, null, `?page=${this.page}`);

        let params = {
          page: this.page,
          blockId: $('.page__item--active').data('id')
        };

        EventBus.$emit('setPagination', params);
      }
    }
  }
</script>
